/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Update_Team_SuccessInputs */



/**
* | output |
* | --- |
* | "Team permissions updated successfully!" |
*
* @param {Spaces_Update_Team_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_update_team_success = /** @type {((inputs?: Spaces_Update_Team_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Update_Team_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Team-Berechtigungen erfolgreich aktualisiert!")
	return /** @type {LocalizedString} */ ("Team permissions updated successfully!")
});